<template>
    <div>
        <named-value
            :name="title"
            variant="stacked"
        />
        <named-value
            v-for="passenger in passengers"
            :key="passenger.id"
            secondary
        >
            {{ passenger.count }} {{ passenger.name }}
        </named-value>

        <spacer />

        <named-value :name="texts.valid_from">
            {{ validFrom | momentDateAndTime }}
        </named-value>

        <named-value :name="texts.valid_to">
            {{ validTo | momentDateAndTime }}
        </named-value>

        <template v-if="description">
            <spacer />

            <named-value
                :name="texts.description"
                variant="stacked"
            >
                {{ description }}
            </named-value>
        </template>

        <template v-if="validity">
            <spacer />

            <named-value
                :name="texts.validity"
                variant="stacked"
            >
                {{ validity }}
            </named-value>
        </template>
    </div>
</template>

<script>
import NamedValue from "@/components/elements/NamedValue";

export default {
    components: {
        NamedValue
    },
    props: {
        texts: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        validFrom: {
            type: Object,
            required: true
        },
        validTo: {
            type: Object,
            required: true
        },
        passengers: {
            type: Array,
            required: true
        },
        description: {
            type: String,
            default: null
        },
        validity: {
            type: String,
            default: null
        }
    }
};
</script>
